import { lazy } from 'react';

const WisdomModule = lazy(() => import('../components/legacy/WisdomModule'));
const LoveCouponsModule = lazy(() => import('../components/legacy/LoveCouponsModule'));
const InstantCameraModule = lazy(() => import('../components/legacy/InstantCameraModule'));
const LovePromiseModule = lazy(() => import('../components/legacy/LovePromiseModule'));
const ProductIdentityModule = lazy(() => import('../components/legacy/ProductIdentityModule'));
const MediaModule = lazy(() => import('../components/legacy/MediaModule'));
const MediaComboModule = lazy(() => import('../components/legacy/MediaComboModule'));
const PrimaryMediaModule = lazy(() => import('../components/legacy/PrimaryMediaModule'));

const LEGACY_MODULE_COMPONENTS = {
  wisdom: WisdomModule,
  love_coupons: LoveCouponsModule,
  coupons: LoveCouponsModule,
  instant_camera: InstantCameraModule,
  camera: InstantCameraModule,
  love_promise: LovePromiseModule,
  promise: LovePromiseModule,
  product_identity: ProductIdentityModule,
  product_info: ProductIdentityModule,
  product: ProductIdentityModule,
  media: MediaModule,
  media_module: MediaModule,
  legacy_media: MediaModule,
  media_combo: MediaComboModule,
  media_combo_module: MediaComboModule,
  legacy_media_combo: MediaComboModule,
  primary_media_legacy: PrimaryMediaModule,
  legacy_primary_media: PrimaryMediaModule,
};

export default LEGACY_MODULE_COMPONENTS;
